/* eslint-disable import/no-cycle */

import './Goals.css';

import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import LoadingSpinner from '../shared/components/UIElements/LoadingSpinner';
import { AuthContext } from '../shared/context/auth-context';
import { HeaderNavigation } from '../shared/headerNavigation/HeaderNavigation';
import { useFocusScroll } from '../shared/hooks/useFocusScroll';
import GoalSelector from './children/GoalSelector';
import SingularGoal from './children/SingularGoal';
import { useFetchGoalsQuery, useDeleteGoalMutation } from './goalsApiSlice';
import { setGoals } from './goalsSlice';

export function Goals() {
  const auth = useContext(AuthContext);
  const { t } = useTranslation();
  const goals = useSelector((state: any) => state.goals.goals);
  const [deleteGoalAPI] = useDeleteGoalMutation();
  const { data: goalsData, isLoading: isFetchingGoals, refetch } = useFetchGoalsQuery(auth.token);
  const dispatch = useDispatch();

  const [openGoalSelector, setOpenGoalSelector] = useState(false);

  const handleCloseGoalSelector = () => {
    setOpenGoalSelector(false);
  };

  const handleOpenGoalSelector = () => {
    setOpenGoalSelector(true);
  };

  useEffect(() => {
    if (!isFetchingGoals && goalsData) {
      dispatch(setGoals(goalsData));
    }
  }, [dispatch, goalsData, isFetchingGoals]);

  useEffect(() => {
    refetch();
  }, []);

  useFocusScroll();

  const confirmDeleteGoal = (oldGoal) => {
    deleteGoalAPI({
      token: auth.token,
      goalId: oldGoal.id,
    }).catch((err) => {
      console.log(err);
    });
  };

  return (
    <div id="main_container" className="foryou health-area platform">
      {isFetchingGoals && <LoadingSpinner asOverlay />}
      {openGoalSelector && <GoalSelector handleClose={handleCloseGoalSelector} />}
      {auth.isLoggedIn && (
        <>
          <HeaderNavigation
            bottomBarActionButton={{
              children: t('G037'),
              onClick: handleOpenGoalSelector,
              variant: 'secondary',
            }}
          />

          <div className="goals-container">
            {goals?.length > 0 &&
              goals?.map((goal, index) => (
                <SingularGoal
                  goal={goal.id}
                  key={index}
                  handleOpenGoalSelector={handleOpenGoalSelector}
                  confirmDeleteGoal={confirmDeleteGoal}
                />
              ))}
          </div>
        </>
      )}
    </div>
  );
}

export const bringFocusToGoalsNavBtn = () => {
  const backElement = document.getElementById('goals_nav');
  backElement?.focus();
};
